import {FC} from 'react'
import { SalesReports } from '../../modules/reports/SalesReports'

interface Props {
  readOnly?: boolean
}

const SalesReportsPage: FC<Props> = ({readOnly = false}) => {
  return (
    <>
      <SalesReports />
      {/* TODO: Add read-only mode support to SalesReports component */}
    </>
  )
}

export default SalesReportsPage
